import { type DomainAccessControlConfig } from 'domains/partner-pick-devices/utils/domain/accessControl'
import { Flipper } from 'domains/partner-pick-devices/access-control/flippers'
import { Permission } from 'domains/partner-pick-devices/access-control/permissions'
import AccessControl from 'legacy/components/AccessControl/AccessControl'
import { WarehouseLocationFeature } from 'legacy/common/warehouseLocations'

export const partnerPickDevicesAccessControl: DomainAccessControlConfig = [
  // permissions and warehouseLocationFeatures both must be enabled,
  // but one of either flippers or warehouseFlippers needs to be enabled
  {
    permissions: Permission.ManageShoppers,
    warehouseLocationFeatures: AccessControl.oneOf([
      WarehouseLocationFeature.RetailerPickup,
      WarehouseLocationFeature.RetailerAlcoholDelivery,
    ]),
  },
  {
    permissions: Permission.ManageShoppers,
    warehouseLocationFeatures: AccessControl.oneOf([
      WarehouseLocationFeature.RetailerPickup,
      WarehouseLocationFeature.RetailerAlcoholDelivery,
    ]),
  },
]
